import Constrain from "./Constrain";

class MaxProductsMultiplier extends Constrain {
  static Name = "MAX_PRODUCTS_MULTIPLIER";

  getName(): string {
    return MaxProductsMultiplier.Name;
  }

  getMaxValue(): number {
    return this.value * this.multiplier;
  }

  isValid(value: number, currentAmount: number): boolean {
    return (
      value < this.getMaxValue() && this.getMaxValue() <= value + currentAmount
    );
  }
}

export default MaxProductsMultiplier;
